var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1149 17.37L18.6149 3.87C18.0749 3.33 17.3249 3 16.4999 3H5.99991C4.34991 3 2.99991 4.35 2.99991 6V16.5C2.99991 17.325 3.32991 18.075 3.88491 18.63L17.3849 32.13C17.9249 32.67 18.6749 33 19.4999 33C20.3249 33 21.0749 32.67 21.6149 32.115L32.1149 21.615C32.6699 21.075 32.9999 20.325 32.9999 19.5C32.9999 18.675 32.6549 17.91 32.1149 17.37ZM19.4999 30.015L5.99991 16.5V6H16.4999V5.985L29.9999 19.485L19.4999 30.015Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74991 12C10.9925 12 11.9999 10.9926 11.9999 9.75C11.9999 8.50736 10.9925 7.5 9.74991 7.5C8.50727 7.5 7.49991 8.50736 7.49991 9.75C7.49991 10.9926 8.50727 12 9.74991 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.8b6627ff.svg";
export { ForwardRef as ReactComponent };